import { Controller } from "react-hook-form";
import { FormLabel } from "../FormLabel";
import { FileInput } from "../FileInput";
import { FormErrorLabel } from "../FormErrorLabel";

const FormFileInput = ({
  name,
  label,
  control,
  error,
  isRequired,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label} <span className="text-red-700">{isRequired ? "*" : ""}</span>
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <FileInput
              setFile={field.onChange}
              file={field.value}
              {...field}
              {...rest}
            />
          );
        }}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormFileInput;
